import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* box-sizing border-box: sem isso, 'width: 100% + padding 0 15px' fica
     20px mais largo que o pai, empurrando elementos do header (Ver todos)
     pra fora da area visivel via overflow:hidden do RightColumnGrid. */
  box-sizing: border-box;
  /* padding-bottom 16 garante que o ultimo EmptySlot (border dashed
     ADICIONAR) nao cole no hairline divider que o RightColumnGrid
     coloca entre Velocimetro e o LineChart abaixo. */
  padding: 0 15px 16px;
  max-height: 100%;
  min-height: 0;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  margin: 0;
  /* gap 16px (era 8px) — da respiro entre o gauge da Temperatura Axial
     e os cards "ADICIONAR" dashed adjacentes. Antes os cards ficavam
     visualmente colados, dificultando ver onde um termina e o outro
     comeca. */
  gap: 16px;
  place-items: center;
  width: 100%;
  flex: 1;
  min-height: 0;

  ${(props) =>
    props.isLoading &&
    'display: flex; align-items: center; justify-content: center; height: 100%; width: 100%'}

  @media (max-width: 1485px) {
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr 1fr;
  }

  /* No phone (<=480px) 3 colunas espremem os gauges; cai pra 2 col. */
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 12px;
  }
`;

export const GaugeContainer = styled.div`
  position: relative;
  max-width: 145px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  border-radius: 10px;
  padding: 8px 0;
  :hover {
    box-shadow: none;
  }
  ${(props) =>
    props.selected && `border: 1px solid ${props.theme.colors.orange}`}
`;

// Empty slot — placeholder clicavel pra adicionar variavel aos
// favoritos. Renderizado quando ha menos favoritos que o maximo,
// preenchendo o grid e tornando obvio que mais variaveis podem ser
// adicionadas. Clique navega pra tela de configuracao de favoritos.
export const EmptySlot = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 145px;
  width: 100%;
  min-height: 130px;
  padding: 16px;
  border: 1.5px dashed ${(props) => props.theme.colors.disabled};
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  transition: all 180ms ease;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.55;

  :hover {
    border-color: ${(props) => props.theme.colors.lightblue};
    border-style: solid;
    opacity: 1;
    color: ${(props) => props.theme.colors.lightblue};
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 159, 216, 0.04)'
        : 'rgba(59, 191, 241, 0.06)'};
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.lightblue};
    outline-offset: 2px;
  }
`;

export const EmptySlotPlus = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1.5px solid currentColor;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
`;

export const EmptySlotLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

// Wrapper do Sparkline inline em cada gauge — buffer rolling das ultimas
// amostras dispatchadas pela subscription. Apresenta tendencia de relance
// sem precisar abrir o LineChart grande do Historico.
export const SparklineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 22px;
  margin-top: 2px;
  /* Container vazio quando ha < 2 pontos — Sparkline retorna null */
`;

// Mini-tag 'PADRAO' no canto superior direito dos gauges que sao defaults
// (operador nao favoritou nada — estamos exibindo um conjunto padrao
// inteligente pra ele). Indica que a variavel pode ser substituida.
export const DefaultTag = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 1px 6px;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 159, 216, 0.12)'
      : 'rgba(59, 191, 241, 0.18)'};
  color: ${(props) => props.theme.colors.lightblue};
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  pointer-events: none;
  z-index: 2;
`;

// Banner discreto acima dos gauges quando a tela esta exibindo defaults
// (nenhum favorito ainda). Explica brevemente + CTA pra customizar.
export const DefaultsBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 12px;
  margin-bottom: 6px;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 159, 216, 0.06)'
      : 'rgba(59, 191, 241, 0.10)'};
  border: 1px solid
    ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(0, 159, 216, 0.18)'
        : 'rgba(59, 191, 241, 0.20)'};
  font-size: 11px;
  color: ${(props) => props.theme.colors.label};
  line-height: 1.3;
  flex-shrink: 0;

  strong {
    color: ${(props) => props.theme.colors.lightblue};
    font-weight: 700;
  }
`;

export const DefaultsBannerCTA = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  background: transparent;
  color: ${(props) => props.theme.colors.lightblue};
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 120ms ease, color 120ms ease;
  font-family: inherit;
  flex-shrink: 0;

  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 12px 0 8px;
  width: 100%;
  flex-shrink: 0;
  flex-wrap: wrap;

  #media {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: bold;
  }
`;

// Legenda inline (Normal / Irregular / Atencao) que antes ficava solta
// no rodape. Agora fica no header pra economizar espaco vertical.
export const LegendInline = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 30px 0 0 15px;
`;

export const Label = styled.label`
  font-size: 13px;
  color: ${(props) => props.color};
  margin: 0;
  font-weight: bold;
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.background};
  flex-shrink: 0;
`;

// Antes era um botao com texto "Trocar" + setinha. Agora e um botao com
// uma seta para baixo pequena, hover destacado. Reduz poluicao visual
// embaixo de cada gauge.
export const ChangeVariable = styled.button`
  display: inline-flex;
  width: 28px;
  height: 22px;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 8px;
  cursor: pointer;
  margin-top: 4px;
  padding: 0;
  transition: all 150ms;

  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    border-color: ${(props) => props.theme.colors.lightblue};
    > * {
      border-top-color: ${(props) => props.theme.colors.white};
    }
  }
`;

export const VariablesChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 390px;
  border-radius: 8px;
  padding: 20px 10px 15px 0;
  background: ${(props) => props.theme.colors.card};
  position: absolute;
  z-index: 99;
  box-shadow: ${(props) => `6px 13px 20px ${props.theme.colors.black}`};
  top: ${(props) => props.top}px;
  left: ${(props) =>
    props.window - props.left < 300 ? props.left - 100 : props.left}px;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  height: 40px;
  border-radius: 0px 10px 10px 0px;
  padding: 0 10px;
  background: ${(props) => props.theme.colors.card};
  cursor: pointer;
  display: ${(props) => props.disable && 'none'};
  color: ${(props) => props.theme.colors.label};
  label {
    font-size: 12px;
    font-weight: bold;
    color: inherit;
  }

  :hover {
    background: ${(props) => props.theme.colors.blue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const TrackVertical = styled.div`
  ${(props) => props.style}
  width: 10px;
  border-radius: 10px;
  background: ${(props) => props.theme.colors.lightergrey};
  right: 2px;
  bottom: 2px;
  top: 2px;
`;

export const ThumbVertical = styled.div`
  background: ${(props) => props.theme.colors.green};
  width: 10px;
  border-radius: 10px;
  ${(props) => props.opaque && 'opacity: 0.3'}
`;

export const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: ${(props) => `5px solid ${props.theme.colors.label}`};
  transition: border-top-color 150ms;
`;

export const NoGraphContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
